import { render, staticRenderFns } from "./EditAppointmentPostPayment.vue?vue&type=template&id=6230c41c&scoped=true&"
import script from "./EditAppointmentPostPayment.vue?vue&type=script&lang=js&"
export * from "./EditAppointmentPostPayment.vue?vue&type=script&lang=js&"
import style0 from "./EditAppointmentPostPayment.vue?vue&type=style&index=0&id=6230c41c&prod&scoped=true&lang=css&"
import style1 from "./EditAppointmentPostPayment.vue?vue&type=style&index=1&id=6230c41c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6230c41c",
  null
  
)

export default component.exports